import $ from 'jquery';

export default function () {
	return function (phoneNumber) {
		let pattern = /^(\+36|36|06)?(20|30|31|70)(\d{3})(\d{4})$/;
		return $.trim(phoneNumber).replace(pattern, '+36 $2 $3 $4');
	};
}
